<script setup lang="ts">
const route = useRoute()
const { refresh, isLoggedIn } = useUserInfo()

function focusRefetch() {
    if (!isLoggedIn.value) return

    refresh()
}

useRefetchThrottle({
    refetchInput: () => focusRefetch(),
    useFocus: true,
    key: 'app-layout'
})
</script>

<template>
    <UIApp>
        <NuxtLayout>
            <NuxtPage />

            <LazyOverlayContainer v-if="!route.meta.hideOverlayContainer" />

            <UIIntercomContainer v-if="!route.meta.hideIntercom" />
        </NuxtLayout>
    </UIApp>
</template>
